import { Box, Image, MediaBox, MediaFlex } from "@jewlr/storybook/core"
import loadable from "@loadable/component"
import PropTypes from "prop-types"
import { useState, useCallback } from "react"
import styled from "styled-components"

import {
  AuthenticateContent,
  AuthenticateModalTitle,
  Footnote,
} from "areas/authenticate/components"
import Modal, { closeModal } from "components/modal"
import { jewlr_t, retry } from "helpers/application"
import { to_currency } from "helpers/number"
import withAuth from "hoc/account/with-auth"

const RegisterForm = loadable(() =>
  retry(() => import("areas/authenticate/register-form"))
)

const InfoBox = styled(MediaFlex).attrs({
  greaterThanOrEqual: "tablet",
})`
  background-color: ${(props) => props.theme.colors.lightPink};
  flex-basis: 300px;
  flex-direction: column;
  justify-content: center;
  padding: 10px 16px 20px;
`
const StepTitle = styled.h3`
  color: ${(props) => props.theme.colors.black};
  font-size: 30px;
  font-weight: 300;
  margin-top: 32px;
  text-align: center;
`
const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`
const ListItem = styled.li`
  align-items: center;
  color: ${(props) => props.theme.colors.black};
  display: flex;
  font-size: 18px;
  font-weight: 300;
  margin-bottom: 20px;
`
const Step = styled.span`
  align-items: center;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 50%;
  color: ${(props) => props.theme.colors.primary};
  display: inline-flex;
  height: 30px;
  justify-content: center;
  margin-right: 20px;
  padding: 5px;
  width: 30px;
`
const StepText = styled.span`
  flex: 1 0 0;
`

const ReferralRegister = ({ referralName }) => {
  const [showContent, setShowContent] = useState(false)
  const afterShow = useCallback(() => {
    setShowContent(true)
  })
  return (
    <Modal
      afterShow={afterShow}
      contentClassName="p-0 tablet:p-0"
      headerVariant="float"
      onClose={closeModal}
      show="#referral"
    >
      {showContent && (
        <AuthenticateContent>
          <InfoBox>
            <StepTitle>
              You&apos;ll get a {to_currency(20)} in Jewls
              {!!referralName && ` from ${referralName}`}!
            </StepTitle>
            <List>
              <ListItem>
                <Step>1</Step>{" "}
                <StepText>Welcome! Create your Jewlr account</StepText>
              </ListItem>
              <ListItem>
                <Step>2</Step>{" "}
                <StepText>Check your email for an exclusive 15% offer</StepText>
              </ListItem>
              <ListItem>
                <Step>3</Step>{" "}
                <StepText>
                  Enjoy shopping for {jewlr_t("terms.personalized")}{" "}
                  {jewlr_t("terms.jewelry")}
                </StepText>
              </ListItem>
              <ListItem>
                <Step>4</Step>{" "}
                <StepText>
                  Receive {to_currency(20)} in Jewls with your first purchase
                </StepText>
              </ListItem>
            </List>
            <MediaBox greaterThanOrEqual="tablet" py="50px">
              <Image
                alt="Jewels"
                center
                height="60px"
                src={require("images/account/jewel_group.svg")}
                width="85px"
              />
            </MediaBox>
          </InfoBox>

          <Box
            flex="1"
            m="auto"
            maxWidth="375px"
            px={{ _: 3, desktop: 3, tablet: 2 }}
          >
            <AuthenticateModalTitle>Create an account</AuthenticateModalTitle>
            <RegisterForm />
            <Footnote mt={3}>
              Please note only new members qualify for referral bonus rewards.
            </Footnote>
          </Box>
        </AuthenticateContent>
      )}
    </Modal>
  )
}

ReferralRegister.propTypes = {
  referralName: PropTypes.string,
}

export default withAuth(ReferralRegister)
